import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { useTranslation } from "react-i18next";

const filterC3PositionsSchema = z.object({
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  strategy_from_id_equals: z.coerce.number().optional().nullable(),
  strategy_to_id_equals: z.coerce.number().optional().nullable(),
});

export type FilterC3PositionsSchema = z.infer<typeof filterC3PositionsSchema>;

export function FilterC3Positions() {
  const { t } = useTranslation("tables");
  const fields: Field[] = [
    {
      name: "date",
      type: "dateRange",
      label: t("c3_positions.searchbox.date", { defaultValue: "Date" }),
      from: { name: "date_from" },
      to: { name: "date_to" },
      col_span: 2,
    },
    {
      name: "strategy_from_id_equals",
      label: t("c3_positions.searchbox.strategy_from_id_equals", { defaultValue: "Strategy from ID" }),
      type: "input",
    },
    {
      name: "strategy_to_id_equals",
      label: t("c3_positions.searchbox.strategy_to_id_equals", { defaultValue: "Strategy to ID" }),
      type: "input",
    },
  ];
  return (
    <FilterTable
      schema={filterC3PositionsSchema}
      client={Clients.C3}
      tableName={Tables.C3_POSITIONS}
      fields={fields}
      columns={2}
    />
  );
}
